import { CoachingInsightComponentAttributes } from '../../coaching-insight/oa/models/coaching.global.model';
import { CardRowData } from '../models/card-row-data.model';
import { MyCoachingCard } from '../models/my-coaching-card.model';
import { OaScoreType } from '../models/oa-score-type.enum';
import { StagingKpiThreshold } from '../models/staging-kpi-threshold.model';

import { getCardRowData } from './get-card-row-data.function';
import { getMenuData } from './get-menu-data.function';
import { getProgressData } from './get-progress-data.function';

export function getCardRowsData(
    card: MyCoachingCard,
    coachingCardThreshold: StagingKpiThreshold[],
    componentAttributes?: CoachingInsightComponentAttributes,
    isTypeFloa?: boolean,
): CardRowData[] {
    const cardRows: CardRowData[] = [];
    card.oaSummary
        .filter((row) => row.type !== OaScoreType.Site_OA)
        .forEach((e) => {
            const dropdownMenuData =
                e.type === OaScoreType.OA && isTypeFloa === false
                    ? getMenuData(card.oaSummary)
                    : null;
            cardRows.push({
                id: e.type,
                rowData: getCardRowData(e, isTypeFloa),
                progressData: getProgressData(
                    e,
                    coachingCardThreshold,
                    componentAttributes,
                    isTypeFloa,
                ),
                dropdownMenuData,
            });
        });

    return cardRows;
}
